import React from 'react';
import './styles.css';

const FormControlLabel = ({
  control,
  label,
  value,
  checked,
  onChange,
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <div className={`custom-form-control-label ${className}`} {...props}>
      {React.cloneElement(control, {
        value,
        checked,
        onChange,
        disabled,
      })}
      <span className="form-control-label-text">{label}</span>
    </div>
  );
};

export default FormControlLabel;
